/** Top-level route configuration for the TradeMind AI X frontend. */

import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Backtesting from "@/pages/Backtesting";
import BudgetAllocation from "@/pages/BudgetAllocation";
import CompanyReport from "@/pages/CompanyReport";
import Dashboard from "@/pages/Dashboard";
import Market from "@/pages/Market";
import Portfolio from "@/pages/Portfolio";
import Research from "@/pages/Research";
import RiskDashboard from "@/pages/RiskDashboard";
import Settings from "@/pages/Settings";
import Watchlist from "@/pages/Watchlist";

export default function App(): React.ReactElement {
  return (
    <Routes>
      {/* Sign-in is disabled — old auth routes just open the app. */}
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="/register" element={<Navigate to="/" replace />} />

      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/market" element={<Market />} />
        <Route path="/research" element={<Research />} />
        <Route path="/research/:companyId" element={<CompanyReport />} />
        <Route path="/allocation" element={<BudgetAllocation />} />
        <Route path="/backtesting" element={<Backtesting />} />
        <Route path="/risk" element={<RiskDashboard />} />
        <Route path="/watchlist" element={<Watchlist />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/settings" element={<Settings />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
